var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinkoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40.0001V20.1171C40.0001 25.2743 37.2489 30.0398 32.7829 32.6186L20 40L7.21719 32.6186C2.75113 30.0398 0 25.2743 0 20.1171V0Z",
    fill: "#FFDD2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9785 10.5889V16.8457C11.8341 15.8795 13.3897 15.2256 15.1684 15.2256H17.1013V22.4992C17.1013 24.4342 16.5755 26.128 15.7954 27.0597H24.2031C23.4247 26.1271 22.9001 24.4354 22.9001 22.5028V15.2256H24.8331C26.6117 15.2256 28.1673 15.8795 29.023 16.8457V10.5889H10.9785Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinkoff);
export default __webpack_public_path__ + "static/media/tinkoff.8bd9bf8cb9b38d90a75137a0d49d6222.svg";
export { ForwardRef as ReactComponent };